module.exports = __webpack_public_path__ + "img/charisma@2x.f1d877a.jpg";